import {VM} from '@hetao/scratch-core';

const UPDATE_TOOLBOX = 'scratch-gui/toolbox/UPDATE_TOOLBOX';
import makeToolboxXML from '../lib/make-toolbox-xml';
import whiteListToolboxXML from '../lib/whiteListToolboxXML';

const defaultVM = new VM();
const toolboxXml = defaultVM.getToolbox();
const bol = toolboxXml && toolboxXml.includes('block');
let defaultXml = '';
if (bol) {
    whiteListToolboxXML(true).then(res => {
        defaultXml = res.xml;
    });
}

const initialState = {
    toolboxXML: bol ? defaultXml : makeToolboxXML(true)
};

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
    case UPDATE_TOOLBOX:
        return Object.assign({}, state, {
            toolboxXML: action.toolboxXML
        });
    default:
        return state;
    }
};

const updateToolbox = function (toolboxXML) {
    return {
        type: UPDATE_TOOLBOX,
        toolboxXML: toolboxXML
    };
};

export {
    reducer as default,
    initialState as toolboxInitialState,
    updateToolbox
};
